var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProsecaptainWriter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#E4ECE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4734 38.1767C36.4713 39.9124 33.9661 39.9124 32.964 38.1767L22.9201 20.7803C21.918 19.0446 23.1706 16.8749 25.1749 16.8749L45.2625 16.8749C47.2668 16.8749 48.5194 19.0446 47.5173 20.7803L37.4734 38.1767Z",
    fill: "url(#paint0_linear_1450_16011)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0359 38.1767C22.0338 39.9124 19.5286 39.9124 18.5265 38.1767L8.48262 20.7803C7.48052 19.0446 8.73315 16.8749 10.7374 16.8749L30.825 16.8749C32.8293 16.8749 34.0819 19.0446 33.0798 20.7803L23.0359 38.1767Z",
    fill: "url(#paint1_linear_1450_16011)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2795 16.877C33.1014 16.8771 34.24 18.8489 33.3293 20.4268L28.0442 29.5791L22.76 20.4268C21.8492 18.8489 22.9879 16.877 24.8098 16.877H31.2795Z",
    fill: "url(#paint2_linear_1450_16011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1450_16011",
    x1: 18.414,
    y1: 42.2815,
    x2: 18.414,
    y2: 8.27306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42367A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F61AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1450_16011",
    x1: 20.7812,
    y1: 42.082,
    x2: 20.7812,
    y2: 8.40216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63AD61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841346,
    stopColor: "#C5D9C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1450_16011",
    x1: 14.7423,
    y1: 16,
    x2: 14.7423,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F61AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsecaptainWriter);
export default __webpack_public_path__ + "static/media/prosecaptain-writer.631ac3b536457a04a7cda8397daa939f.svg";
export { ForwardRef as ReactComponent };